import React from 'react'
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'

export const bugsnagClient = bugsnag({
  apiKey: window.location.hostname === 'homevest.co'
    ? '55c054d53c076601d25dcebb6fadd09c'
    : '5eebe1da74e94b88b888014abe16dd1a',
  beforeSend: function (report) {
    // Disable reporting of Network Errors and Loading chunk failed errors
    if (
      report.errorMessage.includes('Network Error') ||
      (
        report.errorMessage.includes('Loading') &&
        report.errorMessage.includes('chunk') &&
        report.errorMessage.includes('failed')
      )
    ) {
      report.ignore()
    }
  }
})

bugsnagClient.use(bugsnagReact, React)

export const logError = (message, notify) => {
  console.error(message)

  if (notify) {
    bugsnagClient.notify(
      message instanceof Error
        ? message
        : new Error(message)
    )
  }
}
